(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaInstruction', RcopiaInstruction);

    RcopiaInstruction.$inject = ['$resource'];

    function RcopiaInstruction ($resource) {
        var resourceUrl =  'api/rcopia-instructions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
